import { showToast } from '@stenajs-webui/modal';
import { toast } from 'react-toastify';
import type { UrgentMessage } from '../../../common/graphql/fragments/gql/UrgentMessage';
import { BookingResultToastContent } from '../../../use-cases/notifications/toasts/BookingResultToast';
import { UrgentMessageToastContent } from '../../../use-cases/notifications/toasts/UrgentMessageToast';
import type { NotificationResult } from '../notificationsActions';

const BOOKING_RESULT_DURATION_MS = 10000;
const URGENT_MESSAGE_DURATION_MS = 15000;

export const showBookingResultToast = (result: NotificationResult, toastId?: string) => {
  showToast(
    ({ closeToast }) => <BookingResultToastContent result={result} closeToast={closeToast} />,
    {
      toastId,
      className: `t_booking_toast_${result.type}`,
      autoClose: BOOKING_RESULT_DURATION_MS,
    },
  );
};

export const showUrgentMessageToast = (urgentMessage: UrgentMessage) => {
  showToast(
    ({ closeToast }) => (
      <UrgentMessageToastContent urgentMessage={urgentMessage} closeToast={closeToast} />
    ),
    {
      toastId: urgentMessage.id,
      autoClose: URGENT_MESSAGE_DURATION_MS,
    },
  );
};

if (typeof window !== 'undefined') {
  Object.assign(window, { dismissAllToasts: () => toast.dismiss() });
}
